export enum ApplicationState {
  NEW = "NEW",
  DRAFT = "DRAFT",
  SUBMITTED = "SUBMITTED",
  COMPLETED = "COMPLETED",
  SOFT_APPROVED = "SOFT_APPROVED",
  APPROVED = "APPROVED",
  INVOICE_COLLECTED = "INVOICE_COLLECTED",
  MANDATED = "MANDATED",
  COLLATERAL_VERIFIED = "COLLATERAL_VERIFIED",
  SIGNED = "SIGNED",
  AGREEMENT_COMPLETED = "AGREEMENT_COMPLETED",
  DISBURSED = "DISBURSED",
  REJECTED = "REJECTED",
  PENDING_VERIFICATION = "PENDING_VERIFICATION",
  VERIFICATION_COMPLETE = "VERIFICATION_COMPLETE",
}

export enum Role {
  ADMIN = "ADMIN",
  SALES_USER = "SALES_USER",
  BACK_OFFICE_USER = "BACK_OFFICE_USER",
  FIELD_USER = "FIELD_USER",
  SALES_MANAGER = "SALES_MANAGER",
}

export enum Action {
  VIEW_APPLICATION = "VIEW_APPLICATION",
  EDIT_APPLICATION = "EDIT_APPLICATION",
  CREATE_APPLICATION = "CREATE_APPLICATION",
  SAVE_APPLICATION = "SAVE_APPLICATION",
  SUBMIT_APPLICATION = "SUBMIT_APPLICATION",
  UPLOAD_DOCUMENT = "UPLOAD_DOCUMENT", // Temporary
  SOFT_APPROVE = "SOFT_APPROVE",
  REQUEST_EDIT_APPLICATION = "REQUEST_EDIT_APPLICATION",
  REJECT_APPLICATION = "REJECT_APPLICATION",
  VIEW_USER_LOGIN_HISTORY = "VIEW_USER_LOGIN_HISTORY",
  SANCTION = "SANCTION",
  INVOICE_COLLECTED = "INVOICE_COLLECTED",
  MANDATE = "MANDATE",
  SIGN = "SIGN",
  DISBURSE = "DISBURSE",
  COPY_PAST_TABLE = "COPY_PAST_TABLE",
  REOPEN_APPLICATION = "REOPEN_APPLICATION",
  START_VERIFICATION = "START_VERIFICATION",
  VERIFICATION_COMPLETE = "VERIFICATION_COMPLETE",
  // Temporary
}
